<script lang="ts">
  import type { EditImageActor } from "./editImageMachine";
  import { updateField } from "./editImageMachine";
  import { orgAiContent, orgClose, orgPlus } from "@nrk/origo";

  export let service: EditImageActor;
  export let keywords: string[];
  export let detectedLabels: { name: string }[];
  export let _startLabelDetection: () => Promise<void>;

  let isDetectingLabels = false;
  let errorMessage: string | null = null;
  async function handleStartLabelDetection() {
    errorMessage = null;
    isDetectingLabels = true;
    try {
      await _startLabelDetection();
    } catch (error) {
      errorMessage = "Kunne ikke hente KI-genererte forslag. Prøv igjen senere.";
    } finally {
      isDetectingLabels = false;
    }
  }

  function getKeywordsFromDetectedLabels(detectedLabels: { name: string }[]): string[] {
    return detectedLabels.map((label) => label.name);
  }

  $: aiKeywordsOriginal = getKeywordsFromDetectedLabels(detectedLabels);
  $: aiKeywords = aiKeywordsOriginal.filter((k) => !keywords.includes(k));
  let newKeywordValue: HTMLInputElement;
  let keywordsContainer: HTMLDivElement;

  function addKeyword() {
    const trimmed = newKeywordValue.value.trim();
    const newKeyword = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);

    if (newKeyword && !keywords?.includes(newKeyword)) {
      keywords = [...keywords, newKeyword];
      updateField(service, "keywords", keywords);
      newKeywordValue.value = "";
    }
    setTimeout(() => {
      keywordsContainer?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, 50);
  }
</script>

<div>
  <label style="position: relative; margin-top: -0.5rem">
    Manuelle tagger
    <div style="display: flex">
      <input
        bind:this={newKeywordValue}
        type="text"
        id="keywords"
        class="org-input"
        placeholder="Legg til tagg"
        on:keydown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            addKeyword();
          }
        }}
      />
      <button
        type="button"
        class="org-button org-button--secondary"
        style="margin-left: var(--org-small); width: 7.5rem"
        on:click={addKeyword}
        >{@html orgPlus} Legg til
      </button>
    </div>
  </label>
  <div bind:this={keywordsContainer} style="margin-top: var(--org-small);">
    {#each keywords as keyword (keyword)}
      <span class="org-tag keywords">
        {keyword}
        <button
          type="button"
          data-org-tooltip="Fjern"
          class="org-button"
          style="margin-left: var(--org-xsmall); padding:0px; min-width:0px;"
          on:click={() => {
            keywords = keywords.filter((k) => k !== keyword);
            if (aiKeywordsOriginal.includes(keyword) && !aiKeywords.includes(keyword)) {
              aiKeywords = [...aiKeywords, keyword];
            }
            updateField(service, "keywords", keywords);
          }}
        >
          {@html orgClose}
        </button>
      </span>
    {/each}
  </div>
  {#if aiKeywords.length > 0}
    <div style="margin-top: var(--org-small);">
      <label for="aiKeywords">Forslag (KI-generert)</label>
      <div id="aiKeywords">
        {#each aiKeywords as aiKeyword, index (index)}
          <button
            type="button"
            on:click={() => {
              if (!keywords.includes(aiKeyword)) {
                keywords = [...keywords, aiKeyword];
                aiKeywords = aiKeywords.filter((k) => k !== aiKeyword);
                updateField(service, "keywords", keywords);
              }
            }}
            class="org-tag org-tag--suggestive keywords"
          >
            {@html orgPlus}
            Legg til "{aiKeyword}"
          </button>
        {/each}
      </div>
    </div>
  {:else if detectedLabels.length === 0}
    <div class="suggest-button">
      <button
        on:click={handleStartLabelDetection}
        disabled={isDetectingLabels}
        class="org-tag org-tag--suggestive"
        type="button"
      >
        {@html orgAiContent}
        {#if isDetectingLabels}
          <span>
            Henter KI-forslag..
            <span
              style="padding-left:4em; padding-top: var(--org-xsmall); font-size: var(--org-xsmall);"
              class="org-spinner"
            />
          </span>
        {:else}
          <span>Hent KI-forslag</span>
        {/if}
      </button>
      {#if errorMessage}
        <div class="org-warn" role="alert">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/if}
</div>

<style>
  .keywords {
    margin-right: var(--org-small);
  }
  .suggest-button {
    position: relative;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin: var(--org-xsmall);
  }
  .suggest-button button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
</style>
